import { ELECTRON_USER_AGENT_MARKER } from '@griply/types';

import { subscribeToElectronTaskCreate } from './subscribe-to-electron-task-create';
import { subscribeToTaskCreationDataRequest } from './subscribe-to-task-creation-data-request';

export const initElectronCommunication = () => {
  const isTrustedElectronApp = navigator.userAgent.includes(
    ELECTRON_USER_AGENT_MARKER,
  );
  if (!isTrustedElectronApp) {
    return;
  }

  subscribeToElectronTaskCreate();
  subscribeToTaskCreationDataRequest();
};
